<script>
import util from "@/libs/util";
export default {
  name: "add-tian-map",
  props: {
    center: Array,
    // currentElevatorName:String,
    show:{
      type:Boolean,
      default:false
    },
  },
  watch:{
    show:{
      handler(newVal, oldVal) {
        console.log('show 发生变化', newVal,oldVal);
        if(newVal){
          this.loadMapScript()
        }else{
          this.destroyMap()
        }
      },
      deep: false, // 深度监听对象内部属性变化
      immediate: false // 初始化时立即执行一次
    }
  },
  data() {
    return {
      map: null, // 地图实例
      currentLabel:null,
      currentAddMarker:null,
      key: '61e9ee505078172d2ea9f7c7527be6e6', // 替换为你的密钥
      markers: [], // 存储所有标记点实例，便于后续销毁
      labels:[],
      pointList:[],
      zoom: 12 // 初始缩放级别
    }
  },
  beforeDestroy() {
    console.log("子组件被销毁beforeDestroy");
    this.destroyMap();
  },
  methods: {
    // 加载天地图脚本
    loadMapScript() {
      if (window.T) {
        this.initMap()
        return
      }

    },


    // 初始化地图
    initMap() {
      // 创建地图实例
      // this.pointList = this.center;

      try{
        this.map = new window.T.Map('mapContainer2', {
          projection: 'EPSG:4326' // 使用WGS84坐标系
        })

        // 设置地图中心点和缩放级别
        this.map.centerAndZoom(
            new window.T.LngLat(this.center[0], this.center[1]),
            this.zoom
        )
        console.log("初始化地图实例====>",this.map);
        // 添加地图控件
        this.addMapControls();

        // 监听地图事件
        this.bindMapEvents();

        // 初始化所有地图点 如果是默认北京的点 也不现实

        if(this.center[0] === 116.414537 && this.center[1] === 39.915795){
          console.log("默认初始点");
        }else{
          // this.pointList = [{lng:this.center[0],lat:this.center[1],dname:this.currentElevatorName,address:''}];
          // this.addMarkers(this.pointList)
          const lngLat = new window.T.LngLat(this.center[0], this.center[1])
          const marker = new window.T.Marker(lngLat,{
            title:""
          })
          // 添加到地图
          this.map.addOverLay(marker)
          // 存储标记点实例，便于后续清除
          this.markers.push(marker)
        }

      }catch (e){
        console.log(e);
      }
      this.map.checkResize();

    },

    // 清除所有点
    clearMarkers(){
      if(this.map){
        this.markers.forEach(marker => {
          this.map.removeOverLay(marker)
        })
        this.markers = []
      }

    },
    hideCurrentAddMarker(){
      if (this.currentAddMarker) {
        this.map.removeOverLay(this.currentAddMarker) // 从地图移除
      }
      this.currentAddMarker = null;
    },
    // 显示label
    showLabel(lngLat,dname){

      // 1. 隐藏当前已显示的标注
      this.hideCurrentLabel()
      const label = new window.T.Label({
        text:dname,
        position: lngLat, // 标注位置（与标记点相同）
        offset: new window.T.Point(20, 0) // 文字偏移（避免遮挡标记点）
      })
      this.map.addOverLay(label)
      this.labels.push(label)
      this.currentLabel = label

    },

    // 隐藏label
    hideCurrentLabel(){
      if (this.currentLabel) {
        this.map.removeOverLay(this.currentLabel) // 从地图移除
        this.currentLabel = null // 清空记录
      }
    },

    // 清除所有标注对象
    clearLabels(){
      if(this.map){
        this.labels.forEach(label => {
          this.map.removeOverLay(label)
        })
        this.labels = []
      }
    },

    // 销毁地图
    destroyMap(){
      // 销毁地图实例，释放资源
      if (this.map) {
        this.clearMarkers() // 销毁前清除标记
        this.clearLabels();
        console.log(this.map);
        //  // 销毁
        let mapContainer = document.getElementById("mapContainer2");
        let mapBox = document.getElementById("map-box2");
        if(mapContainer) mapBox.removeChild(mapContainer);
        const newChildMapContainer = document.createElement("div");
        newChildMapContainer.id = "mapContainer2";
        newChildMapContainer.className = "map-container";
        newChildMapContainer.style="width:100%;height:100%";
        mapBox.append(newChildMapContainer);
      }
      this.map = null;
    },

    // 添加地图控件
    addMapControls() {
      // 添加比例尺控件
      this.map.addControl(new window.T.Control.Scale())

      // 添加缩放控件
      this.map.addControl(new window.T.Control.Zoom())

      // 添加地图类型切换控件
      this.map.addControl(new window.T.Control.MapType({
        mapTypes: [
          window.TMAP_NORMAL_MAP,    // 标准地图
          // window.TMAP_SATELLITE_MAP, // 卫星地图
          // window.TMAP_TERRAIN_MAP    // 地形地图
        ]
      }))
    },

    // 绑定地图事件
    bindMapEvents() {
      // 地图点击事件
      this.map.addEventListener('click', (e) => {
        // console.log('点击位置经纬度：', e.lnglat.getLng(), e.lnglat.getLat())
        //   清除当前显示Label
        this.hideCurrentLabel();
        //   判断是否是添加点操作
          let lng = e.lnglat.getLng();
          let lat = e.lnglat.getLat();
          const newLngLat = new window.T.LngLat(lng, lat)
          //  创建并添加标记点
          const newMarker = new window.T.Marker(newLngLat)
          this.clearMarkers()
          this.map.addOverLay(newMarker)
          this.markers.push(newMarker);
          this.currentAddMarker = newMarker;
          const geocoder = new window.T.Geocoder();
          geocoder.getLocation(newLngLat, (data)=>{
            console.log('地址解析结果参数：',data);
            let status = data.status;
            let address = "";
            if(status === "0"){
              address = data.formatted_address;
            }
            this.$emit('onClickAdd',{lng,lat,address})
          });
      })

      // 地图移动结束事件
      // this.map.addEventListener('moveend', () => {
      //   const center = this.map.getCenter()
      //   // console.log('当前中心点：', center.getLng(), center.getLat())
      // })
    },

    // 设置地图点
    // 批量添加标记点
    addMarkers(points) {
      console.log('触发添加点操作：',points);
      if (!points.length || !this.map) return

      points.forEach(point => {
        // 校验经纬度格式
        if (!point.lng || !point.lat) return


        // 创建坐标对象
        const lngLat = new window.T.LngLat(point.lng, point.lat)
        const marker = new window.T.Marker(lngLat,{
          title:point.dname || this.$t("l.unknown_location")
        })
        // console.log(lngLat,marker);
        // 给标记点添加自定义信息（如名称）
        // marker.setName(point.dname || '未知地点')

        // 添加点击事件（可选）
        // marker.addEventListener('click', () => {
        //   console.log("marker:", marker);
        //   this.showLabel(lngLat,"【"+point.dname+"】"+(point.address?point.address:this.$t("l.unset_elevator_address")));
        //
        // })

        // 添加到地图
        this.map.addOverLay(marker)
        // 存储标记点实例，便于后续清除
        this.markers.push(marker)
      })
    },

    // // 地图放大
    // zoomIn() {
    //   this.map.zoomIn()
    // },
    //
    // // 地图缩小
    // zoomOut() {
    //   this.map.zoomOut()
    // },
    //
    // // 重置地图
    // resetMap() {
    //   this.map.centerAndZoom(
    //       new window.T.LngLat(this.center[0], this.center[1]),
    //       this.zoom
    //   )
    // }
  }
}
</script>

<template>
  <div class="map-wrapper" id="map-box2">
    <div id="mapContainer2"  class="map-container"></div>
  </div>
</template>

<style scoped>
.map-wrapper {
  position: relative;
  width: 100%;
  height: 800px;
}

#mapContainer2 {
  width: 100%;
  height: 100%;
}

.map-actions {
  position: absolute;
  top: 20px;
  left: 20px;
  z-index: 100;
  display: flex;
  gap: 10px;
}

.action-btn {
  padding: 8px 12px;
  background-color: #42b983;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  transition: background-color 0.3s;
}

.action-btn:hover {
  background-color: #359e75;
}
</style>